import React from "react";
import Plantilla from "../../../images/dashboardAbogados/Plantillas.svg";
function NoStatusScreen({ text }) {
  return (
    <div className="noPlantillas noInfo--screen">
      <p className="textNoPlantillas font-weight-bold">
        {text ? text : "No hay plantillas para estatus"}
      </p>
      <img src={Plantilla} alt="Imagen3" />
    </div>
  );
}

export default NoStatusScreen;
